// Import asset images
import './images';

// Import javascript
// import debounce from './helpers/debounce';

/*import siteMenu from './partials/siteMenu';
import sliders from './partials/sliders';
import buttons from './partials/buttons';
import combos from './partials/combo';
import scroll from './partials/scroll';
import animation from './partials/animations';
import analytics from './partials/analytics';*/

import faq from './partials/faq';
import features from './partials/features';
import filters from './partials/filters';
import lazyload from './partials/lazyload';
import form from './partials/form';
import swiper from './partials/swiper';
import oembed from './partials/oembed';
import signup from './partials/ecommerce/signup';

document.addEventListener('DOMContentLoaded', function () {
  /*siteMenu();
  analytics();
  sliders();
  buttons();
  combos();
  scroll();
  animation();*/
  faq();
  features();
  filters();
  lazyload();
  form();
  swiper();
  oembed();

  // Ecom signup: also initialises its PriceCalculator internally.
  signup();

  window.addEventListener('resize', function () {
    document.documentElement.style.setProperty(
      '--vh',
      window.innerHeight * 0.01 + 'px'
    );
  });
});
